import { render, staticRenderFns } from "./Airports.vue?vue&type=template&id=3d2d085d&scoped=true&"
import script from "./Airports.vue?vue&type=script&lang=js&"
export * from "./Airports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2d085d",
  null
  
)

export default component.exports